import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
Hi, I'm Averi.
    </Text>
    <p>{`I'm a Developer Relations engineer at Google focused on improving the serverless experience on Google Cloud Platform.`}</p>
    <p>{`Before Google, I worked as a `}<a parentName="p" {...{
        "href": "https://scholar.google.com/citations?user=UoQxEKYAAAAJ&hl=en"
      }}>{`researcher in the medical imaging field`}</a>{`, developing image analysis software and image processing pipelines.`}</p>
    <p>{`In my spare time, I enjoy playing competitive rugby, splicing together GoPro video, and hanging out in a hammock.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      